import type { LayoutSize } from './useLayoutSize';
import useLayoutSize from './useLayoutSize';

function useIsLayoutSize(size: LayoutSize) {
  const currentSize = useLayoutSize();
  return size === currentSize;
}

export default useIsLayoutSize;
